import Usuario from './Usuario'
import LoteRemessaCorreio from './LoteRemessaCorreio'
import AutoInfracaoTransito from './AutoInfracaoTransito'
import Processo from './Processo'
import NotificacaoPendente from './NotificacaoPendente'
import PessoaAutoInfracaoTransito from './PessoaAutoInfracaoTransito'

class Notificacao {
    constructor(
        {
            id = null,

            lote_remessa_correio_id = null,
            auto_infracao_transito_id = null,
            faixa_cep_correio_id = null,
            numero_notificacao = null,
            data_emissao = null,
            data_postagem = null,
            data_publicacao_dom = null,
            data_inclusao_emissao_sram = null,
            data_inclusao_postagem_sram = null,
            data_inclusao_publicacao_sram = null,
            ind_erro_sram = null,
            pessoa_titular_infracao_id = null,
            processo = [],
            solicitacao_fici = [],

            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            usuario = {},
            notificacao_pendente={},
            lote_remessa_correio = {},
            auto_infracao_transito = {},
            pessoa_titular_infracao = {},


        } = {}
    ) {

        this.id = id;
        
        this.lote_remessa_correio_id = lote_remessa_correio_id;
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.faixa_cep_correio_id = faixa_cep_correio_id;
        this.data_emissao = data_emissao;
        this.data_postagem = data_postagem;
        this.numero_notificacao = numero_notificacao;
        this.data_publicacao_dom = data_publicacao_dom;
        this.data_inclusao_emissao_sram = data_inclusao_emissao_sram;
        this.data_inclusao_publicacao_sram = data_inclusao_publicacao_sram;
        this.data_inclusao_postagem_sram = data_inclusao_postagem_sram;
        this.ind_erro_sram = ind_erro_sram;
        this.pessoa_titular_infracao_id = pessoa_titular_infracao_id;
        this.solicitacao_fici = solicitacao_fici;
        
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;

        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.lote_remessa_correio = lote_remessa_correio ? new LoteRemessaCorreio(lote_remessa_correio) : new LoteRemessaCorreio();
        this.auto_infracao_transito = auto_infracao_transito ? new AutoInfracaoTransito(auto_infracao_transito) : new AutoInfracaoTransito();
        this.processo = processo && Array.isArray(processo) && processo.length > 0 ? processo.map(nt => {return new Processo(nt)}) : [];
        this.notificacao_pendente = notificacao_pendente ? new NotificacaoPendente(notificacao_pendente) : new NotificacaoPendente();
        this.pessoa_titular_infracao = pessoa_titular_infracao ? new PessoaAutoInfracaoTransito(pessoa_titular_infracao) : new PessoaAutoInfracaoTransito();

    }
}

export default Notificacao;